<template>
  <div class="category-list-item">
    <img :src="iconUrl" :alt="`${name} category icon`" class="icon" />
    <div class="meta">
      <router-link v-if="route" :to="route" class="name">{{
        name
      }}</router-link>
      <div v-else class="name">{{ name }}</div>
      <div v-if="showServiceCount" class="count">
        มีทั้งหมด {{ serviceCount }} บริการ
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconUrl: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    route: {
      type: Object,
      default: null
    },
    serviceCount: {
      type: Number,
      default: null
    }
  },
  computed: {
    showServiceCount() {
      return this.serviceCount != null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$iconSize: 48px;

.category-list-item {
  display: grid;
  grid-template-columns: 48px auto;
  grid-gap: 30px;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .icon {
    display: block;

    border-radius: 8px;
    width: $iconSize;
    height: $iconSize;
  }

  > .meta {
    display: block;
  }
}

.meta > .name {
  line-height: 1.6;
  display: inline-block;

  &:hover {
    color: black;
  }
}

.count {
  font-size: 14px;
}

@media (max-width: 768px) {
  .category-list-item {
    grid-gap: 16px;
    padding: ($space / 2) ($space / 2);
  }

  .category-list-item > .icon {
    width: 40px;
    height: 40px;
  }
}
</style>
